import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  HttpService,
  IdDescription,
  NotificationService,
  ProductPriceListConversion,
  TmsWebBaseEditCreateService,
} from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export class ProductPriceListConversionService extends TmsWebBaseEditCreateService<
  ProductPriceListConversion,
  ProductPriceListConversion
> {
  constructor(protected httpService: HttpService, protected notificationService: NotificationService) {
    super('ProductPriceListConversion', $localize`Product Price List Conversion`, httpService, notificationService);
  }

  getForProduct(id: string): Observable<IdDescription[]> {
    return this.httpService.get<IdDescription[]>(`${this.apiUrl}/GetForProduct/${id}`);
  }

  getForProductForm(id: string): Observable<ProductPriceListConversion[]> {
    return this.httpService.get<ProductPriceListConversion[]>(`${this.apiUrl}/GetForProductForm/${id}`);
  }

  getForProductPriceList(id: string, unitOfMeasureId: string): Observable<ProductPriceListConversion> {
    return this.httpService.get<ProductPriceListConversion>(
      `${this.apiUrl}/GetForProductPriceList?id=${id}&orderUnitOfMeasureId=${unitOfMeasureId}`,
    );
  }
}
